import styled from '@emotion/styled';

import { TextButton } from '@/components/common/Button/style';

export {
	AuthContainer as Container,
	AuthEyebrow as Eyebrow,
	AuthFieldBox as FieldBox,
	AuthFormActions as FormActions,
	AuthFormCard as FormCard,
	AuthMenuBox as MenuBox,
	AuthPage as Page,
	AuthPageHeader as PageHeader,
	AuthSubtitle as Subtitle,
	AuthTitle as Title,
} from '@/styles/authPageLayout';

export { PrimaryButton as Button } from '@/components/common/Button/style';

export const MenuButton = TextButton;
